import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";
import {MODULES} from "@/utils/data/tableCol/projectTableCol";

export const columnsData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
       {
        title: '项目号',
        dataIndex: 'id',
        key: 'id',
            className: 'tdProjectNote',
        scopedSlots: {
            customRender: 'projectId'
        },
    }, {
        title: '合同号',
        dataIndex: 'contractNumber',
        key: 'contractNumber',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            filtered: true,
            customRender: 'foldInfo'
        },
        filteredValue: filteredInfo.contractNumber || [],
    },
        {
            title: '合同签署状态',
            dataIndex: 'bsSignStatus',
            key: 'bsSignStatus',
            scopedSlots: {
                customRender: 'bsSignStatus'
            },
        },
        {
            title: '类型',
            dataIndex: 'projectType',
            key: 'projectType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'foldInfo'
            },
            filteredValue: filteredInfo.projectType || [],
        },
        {
            title: '样本数量',
            dataIndex: 'sampleNumber',
            key: 'sampleNumber',
            isNeedPermit:true,
        }, {
            title: '销售姓名',
            dataIndex: 'salesList',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'salesName'
            },
            filteredValue: filteredInfo.salesName || [],
        }, {
            title: '客户姓名',
            dataIndex: 'customerList',
            key: 'customerName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'customerName'
            },
            filteredValue: filteredInfo.customerName || [],
        }, {
            title: '分析员姓名',
            dataIndex: 'creator.name',
            key: 'analystName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.analystName || [],
        }, {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sortDirections: ["descend", "ascend", "descend"],
        },
        {
            title: '报告审批状态',
            dataIndex: 'passApproval',
            key: 'passApproval',
            scopedSlots: {
                customRender: 'passApproval'
            },
        },
        {
            title: '分析结果状态',
            dataIndex: 'resReleased',
            key: 'resReleased',
            scopedSlots: {
                customRender: 'resReleased'
            },
        },
        {
            title: '原始数据释放详情',
            dataIndex: 'rawDataStatus',
            key: 'rawDataStatus',
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterRawDataStatus',
                filterIcon: 'filterIcon',
                customRender: 'rawDataStatus',
            },
            filteredValue: filteredInfo.rawDataStatus || [],
        },
        {
            title: '项目备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 200,
            scopedSlots: {
                customRender: 'note',
            },
        },
        {
            title: '备注（客户自填）',
            dataIndex: 'customerRemark',
            key: 'customerRemark',
            width: 200,
            scopedSlots: {
                customRender: 'customNote',
            },
        },
        {
            title: '操作',
            width: 200,
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
        },

    ]
}
